module.exports = __webpack_public_path__ + "static/media/tour-reward-grey.2a9d6352.svg";